import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Paper } from '@material-ui/core';
export default styled(Paper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n"])));